import { useState, useCallback, useMemo, useEffect } from 'react';
import styles from './MyCourses.module.scss';
import { HTML5Backend } from 'react-dnd-html5-backend';
import {
  SllCourse,
  useSllGetLessonsLazyQuery,
  SllLesson,
  useSllGetCoursesLazyQuery,
  SllLessonFragment,
  useSllDeleteCourseMutation,
  useSllCreateCourseMutation,
  useSllUpdateCourseMutation,
  useSllUpdateCourseNameMutation
} from '@api/graphql-codegen';
import Spinner from 'src/components/spinner/Spinner';
import Header from 'src/components/header/Header';
import AddCourse from './course-modal/AddCourse';
import GridLessonsLayout from './gridLayout/GridLessonsLayout';
import MainFilterLayout from './filterLayout/MainFilterLayout';
import DeleteModal from '@components/modal/delete-modal/DeleteModal';
import { Collapse } from "react-collapse";
import './customStyle.css';
import {
  useAnalytics,
  Events,
  useUser,
  useQueryParams
} from '@hooks';
import IconPencil from 'src/assets/icons/pencil.svg?react';
import CloseIcon from 'src/assets/icons/close.svg?react';
import RightArrowIcon from 'src/assets/icons/arrow-right-white.svg?react';
import { MyCourseEnum } from '@types';
import TabLayout from './tabLayout/TabLayout';
import Button from '@src/components/button/Button';
import EditCourse from './course-modal/EditCourse';
import { useMediaQuery } from 'react-responsive';
import { TouchBackend } from 'react-dnd-touch-backend';
import {
  DndProvider,
  TouchTransition,
  MouseTransition,
} from 'react-dnd-multi-backend'
// import { TextInput, TextInputValue } from '@src/components/text-input/TextInput';
import SubFilterSelect from './filterLayout/SubFilterSelect';
import LessonProgressModal from '@src/components/lesson-progress-modal/LessonProgressModal';
import { useHistory } from 'react-router-dom';
import { standaloneLessonsAgeLevels, standaloneLessonsAgeOptions, standaloneLessonsSelCompetencies } from '@constants';
import { EditText } from 'react-edit-text';
import { Switch } from 'antd';
import { useToast } from '@src/hooks/useToast';
import { logger } from '../../utils/logger';

export const colors = ['#FFB3B3', '#CADEFC', '#9EE6CF', '#F0D9FF', '#DFF4F3', '#FFCFDF', '#FFDBA4', '#FFD9C0', '#DEECFF', '#CDF0EA', '#FFE9AE', '#C1EFFF', '#D9D6FF', '#FFF3B3'];
export const darkColors = ['#FF7E7E', '#94BFFF', '#4ECCA4', '#BB7AE4', '#69D7D1', '#FC75A2', '#FFB648', '#FFA467', '#A4A8FF', '#69D7C4', '#FAC947', '#51D2FF', '#8075FC', '#FFD600'];

function checkRepeat(array: SllCourse[], el: string) {
  for(var i = 0 ; i < array.length; i++)
    if(array[i].color === el) return true;
  return false;
}

function getRandColor(courses: SllCourse[], array: string[]) {
  var rand = array[Math.floor(Math.random()*array.length)];
  if(!checkRepeat(courses, rand)) {
     return rand;
  }
  return getRandColor(courses, array);
}

const emptyCourse: SllCourse = {
  id: '',
  name: '',
};

function MyCourses() {
  const { trackEvent } = useAnalytics();
  const history = useHistory();
  const params = useQueryParams();
  const tab = params.get('tab');
  const lessonId = params.get('lid');
  const [filters, setFilters] = useState<string[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [showLesson, setShowLesson] = useState(false);
  const [selLesson, setSelLesson] = useState<SllLesson | null>(null);
  const [myCourses, setMyCourses] = useState<SllCourse[]>([]);
  const [showMyCourses, setShowMyCourses] = useState(true);
  // const [search, setSearch] = useState('');
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const [name, setName] = useState('')
  const [color, setColor] = useState<string | null>(null)
  const [myCourseMode, setMyCourseMode] = useState(tab === '2' ? MyCourseEnum.Courses : MyCourseEnum.Library)
  const [selMyCourse, setSelMyCourse] = useState<SllCourse | undefined>(undefined);
  const [removeConfirmation, setRemoveConfirmation] = useState(false);
  const [deletingCourseId, setDeletingCourseId] = useState<string>();
  const [showEditModal, setShowEditModal] = useState(false);
  const [dndLesson, setDndLesson] = useState<string>();
  // Use the same value as $HeaderHeight from _constants.scss
  const HEADER_HEIGHT = 80;
  const [topPos, setTopPos] = useState(HEADER_HEIGHT);
  const [navHidden, setNavHidden] = useState(false);
  const [ageFilter, setAgeFilter] = useState(false);
  const [skillFilter, setSkillFilter] = useState(false);
  const [topicFilter, setTopicFilter] = useState(false);
  const [filteredAge, setFilteredAge] = useState<string[]>([]);
  const [filteredSkill, setFilteredSkill] = useState<string[]>([]);
  const [filteredTopic, setFilteredTopic] = useState<string[]>([]);
  // const [filteredSubTopic, setFilteredSubTopic] = useState<string[]>([]);
  const [isApplied, setIsApplied] = useState(false);
  const [isDefault, setIsDefault] = useState(false);
  const [user] = useUser();
  const [isMovable, setIsMovable] = useState(false);
  const [showLabel, setShowLabel] = useState(false);

  const [hoveredLessonId, setHoveredLessonId] = useState("");
  const [needBottomPadding, setNeedBottomPadding] = useState(false);
  const [cardHovered, setCardHovered] = useState(false);
  const [centerCard, setCenterCard] = useState(false);

  const isComingSoon = true;
  const isTablet = useMemo(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent)
  }, []);

  const isMobile = useMediaQuery({maxWidth: 800});
  const middleWidth = useMediaQuery({maxWidth: 1330});
  const smallWidth = useMediaQuery({maxWidth: 1024});
  const { updateToast, successToast, errorToast } = useToast();

  const [sllGetCourses, {data: myCourseData, loading: courseLoading}] = useSllGetCoursesLazyQuery({fetchPolicy: 'network-only'});
  const [sllGetLessons, {data: sllLessons, loading}] = useSllGetLessonsLazyQuery({
    variables: { input: { ageGroup: [], skill: [], mainTopic: [], subTopic: [], keyword: '' }}, fetchPolicy: 'network-only'});
  const [sllDeleteCourse, { loading: deletingCourse }] = useSllDeleteCourseMutation({
    onCompleted: () => {
      if (deletingCourseId === selMyCourse?.id) {
        setSelMyCourse(undefined)
      }
    }
  });

  useEffect(() => {
    history.replace(`/standalone/lessons?tab=${myCourseMode === MyCourseEnum.Courses ? '2' : '1'}` + (lessonId ? `&lid=${lessonId}` : ''))
  }, [myCourseMode, history, lessonId])

  useEffect(() => {
    if (!lessonId || lessonId === selLesson?.id) return;
    const lesson = sllLessons?.sllGetLessons?.find(l => l.id && l.id === lessonId) as SllLesson
    if (lesson?.id) {
      setSelLesson(lesson);
      history.replace(`/standalone/lessons?tab=${myCourseMode === MyCourseEnum.Courses ? '2' : '1'}&lid=${lesson?.id}`);
      setShowLesson(true);
      trackEvent(Events.actions.standaloneLessonOpen, {
        lesson_name: lesson.name,
        grade: lesson.ageGroup || lesson.gradeLevel,
        skill: lesson.skill,
        ...(lesson.collections && lesson.collections.length && {
          collection_name: lesson.collections.filter(c => c?.collectionType === 'Theme')[0]?.name,
        }),
        ...(lesson.multiCollections && lesson.multiCollections.length && {
          program_name: lesson.multiCollections[0]?.programType || '',
          multi_collection_name: lesson.multiCollections.map(mc => mc?.name),
        }),
        schoolId: user?.schools?.[0]?.id,
        schoolName: user?.schools?.[0]?.name,
        userId: user?.id,
        userName: `${user?.firstName} ${user?.lastName}`,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lessonId, selLesson?.id, sllLessons?.sllGetLessons?.length, trackEvent, user])

  useEffect(() => {
    if (tab === '2') {
      setMyCourseMode(MyCourseEnum.Courses)
    } else {
      setMyCourseMode(MyCourseEnum.Library)
    }
  }, [tab])

  useEffect(() => {
    sllGetCourses();
  }, [sllGetCourses])

  useEffect(() => {
    sllGetLessons({
      variables: { input: { ageGroup: [], skill: [], mainTopic: [], subTopic: [], keyword: '' }}
    });
  }, [sllGetLessons])

  const [sllCreateCourse, {loading: creating}] = useSllCreateCourseMutation({
    onCompleted(data) {
      if (showModal) setShowModal(false);
      if (showEditModal) setShowEditModal(false);
      if (data.sllCreateCourse) {
        const newColor = color ? color : getRandColor(myCourses, colors)
        const foundIdx = colors.findIndex(el => el === newColor)
        const darkColor = darkColors[foundIdx]
        setMyCourses((prev: any) => {
          var oldList = [...prev]
          const plan = {
            id: data.sllCreateCourse,
            name: name,
            color: newColor,
            darkColor,
            lessonIds: dndLesson ? [dndLesson] : (selLesson ? [selLesson.id] : [])
          }
          setSelMyCourse(plan);
          if(dndLesson) setDndLesson(undefined);
          return [...oldList, plan];
        })
        if (selLesson) {
          sllUpdateCourse({
            variables: {
              input: {
                id: data.sllCreateCourse,
                lessonIds: [selLesson.id]
              }
            }
          });
        }
      }
    },
    onError(e) {
      if (showModal) setShowModal(false);
      if (showEditModal) setShowEditModal(false);
      logger.info('error', e.message)
    }
  })

  const handleGoCollection = useCallback((collectionId: string) => {
    const lessonForm = document.getElementById(collectionId);
    if (lessonForm) {
      lessonForm?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  }, []);

  const handleMoveToCollection = useCallback((collection: SllCourse) => {
    setShowLesson(false);
    setSelLesson(null);
    setMyCourseMode(MyCourseEnum.Courses)
    setTimeout(() => {
      handleGoCollection(collection.id)
    }, 500)
    history.replace(`/standalone/lessons?tab=2`);
  }, [handleGoCollection, history])

  const [sllUpdateCourse, {loading: updating}] = useSllUpdateCourseMutation({
    onCompleted(data) {
      if (data.sllUpdateCourse) {
        updateToast('Collection Updated!', <div className={styles.viewButton} onClick={()=>handleMoveToCollection(selMyCourse!)}>View Collection <RightArrowIcon /></div>)
      } else {
        errorToast('Course update is not complete.');
      }
    },
    update(_, __, { variables }) {
      if (variables?.input.id) {
        const index = myCourses.findIndex(plan => plan.id === variables?.input.id);
        if (index > -1) {
          const course = {
            id: variables?.input.id,
            name: myCourses[index].name,
            color: myCourses[index].color,
            darkColor: myCourses[index].darkColor,
            lessonIds: (variables?.input.lessonIds || []) as string[],
          };
          setSelMyCourse(course);
        }
      }
    },
    onError(e) {
      setShowModal(false);
      logger.info('error', e.message)
      errorToast("Course update is not complete.");
    }
  })

  const [sllUpdateCourseName, {loading: updating1}] = useSllUpdateCourseNameMutation({
    onCompleted(data) {
      if (showEditModal) setShowEditModal(false);
      if (data.sllUpdateCourseName) {
        successToast("Courses updated successfully!");
      } else {
        errorToast("Course update is not complete.");
      }
    },
    update(_, __, { variables }) {
      if (variables?.input.id) {
        const index = myCourses.findIndex(plan => plan.id === variables?.input.id);
        if (index > -1) {
          const plan = {
            id: variables?.input.id,
            name: variables.input.name,
            color: myCourses[index].color,
            darkColor: myCourses[index].darkColor,
            lessonIds: myCourses[index].lessonIds,
          };
          const newCourses = JSON.parse(JSON.stringify(myCourses));
          newCourses[index].name = variables.input.name;
          setSelMyCourse(plan);
          setMyCourses(newCourses);
        }
      }
    },
    onError(e) {
      if (showEditModal) setShowEditModal(false);
      logger.info('error', e.message)
      errorToast("Course update is not complete.");
    }
  })

  const lessonsByAge: SllCourse[] = useMemo(() => {
    const newCourses: SllCourse[] = [];
    standaloneLessonsAgeLevels.forEach((grade) => {
      const gradeLessons = sllLessons?.sllGetLessons?.filter(lesson => lesson.gradeLevel === grade).map((lesson) => {
        return lesson.id
      })
      if (gradeLessons && gradeLessons?.length > 0) {
        const color = getRandColor(newCourses, colors);
        const foundIdx = colors.findIndex(el => el === color);
        const darkColor = darkColors[foundIdx];
        newCourses.push({ name: grade, color, darkColor, id: grade, lessonIds: gradeLessons});
      }
    });
    return newCourses;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sllLessons?.sllGetLessons]);

  const showAddNewCourse = () => {
    setSelMyCourse(emptyCourse)
    setMyCourseMode(MyCourseEnum.Library)
    setShowEditModal(true);
    setShowMyCourses(true)
  }
  // Add new Course
  const handleAddNewCourse = useCallback((name: string) => {
    setName(name);
    const color = getRandColor(myCourses, colors);
    setColor(color);
    const foundIdx = colors.findIndex(el => el === color);
    const darkColor = darkColors[foundIdx];

    sllCreateCourse({
      variables: {
        input: {
          name,
          color,
          darkColor
        }
      }
    });
  },[sllCreateCourse, myCourses])

  // Update Course name
  const handleUpdateCourse = useCallback((id: string, name: string, lessonId?: string) => {
    setName(name);
    if (id === "") {
      const color = getRandColor(myCourses, colors);
      setColor(color);
      const foundIdx = colors.findIndex(el => el === color);
      const darkColor = darkColors[foundIdx];

      sllCreateCourse({
        variables: {
          input: {
            name,
            color,
            darkColor,
            lessonId
          }
        }
      });
    } else {
      sllUpdateCourseName({
        variables: {
          input: {
            id,
            name
          }
        }
      });
    }
  },[sllUpdateCourseName, sllCreateCourse, myCourses])

  useEffect(() => {
    if (myCourseData?.sllGetCourses && myCourseData.sllGetCourses.length > 0) {
      var courses: SllCourse[] = [ ...myCourseData?.sllGetCourses || []].map(plan => {
        const color = colors[Math.floor(Math.random() * colors.length)];
        const foundIdx = colors.findIndex(el => el === color)
        const darkColor = darkColors[foundIdx]
        if (!plan.color || !plan.darkColor) {
          return {
            ...plan,
            color: color,
            darkColor: darkColor
          }
        }
        return plan
      });
      setMyCourses(courses)
      if (courses.length > 0) {
        setSelMyCourse(courses[0])
      }
    }
  }, [myCourseData?.sllGetCourses, setMyCourses])

  useEffect(() => {
    if (myCourseData?.sllGetCourses && myCourseData.sllGetCourses.length === 0) {
      if (user?.firstName && !isDefault) {
        setIsDefault(true);
        handleAddNewCourse(user.firstName);
      }
    }
  }, [myCourseData?.sllGetCourses, user?.firstName, isDefault, handleAddNewCourse])

  const filtered = useMemo(() => {
    let filteredLessons: SllLesson[] = sllLessons?.sllGetLessons || [];

    if (filters?.length > 0 && isApplied) {
      if (filteredAge.length > 0) { // filter Age Group
        filteredLessons = filteredLessons.filter(lesson => {
          return lesson.gradeLevel && filteredAge.includes(lesson.gradeLevel);
        });
      }

      if (filteredSkill.length > 0) { // filter Skill
        filteredLessons = filteredLessons.filter(lesson => {
          return lesson.skill && filteredSkill.includes(lesson.skill);
        });
      }

      if (filteredTopic.length > 0) { // filter Main Topic
        filteredLessons = filteredLessons.filter(lesson => {
          let currentTopics = [];
          try {
            currentTopics = lesson.mainTopics ? JSON.parse(lesson.mainTopics) : [];
          } catch {
            currentTopics = [];
          }
          if (!currentTopics?.length) {
            return false;
          }
          return !!currentTopics.some((topic) => filteredTopic.includes(topic));
        });
      }
    }

    if (myCourseMode === MyCourseEnum.Courses) {
      if (selMyCourse) {
        filteredLessons = filteredLessons.filter(lesson => selMyCourse.lessonIds?.includes(lesson.id))
      }
    }
    return filteredLessons;
  }, [filteredAge, filteredSkill, filters, sllLessons?.sllGetLessons, selMyCourse, myCourseMode, isApplied, filteredTopic]);

  // Select child Course
  const handleSelCourse = useCallback((item: SllCourse) => {
    if (selMyCourse === item || myCourseMode === MyCourseEnum.Courses) {
      // showSuccessNotification('Course Updated');
      setSelMyCourse(undefined)
    } else {
      setSelMyCourse(item)
    }

  }, [selMyCourse, myCourseMode])
  // Edit Library
  const handleShowMyCourses = (item: SllCourse) => {
    setMyCourseMode(MyCourseEnum.Library)
    setSelMyCourse(item)
    setShowMyCourses(true)
  }

  const handleEditCourse = (item: SllCourse) => (e: any) => {
    e.stopPropagation()
    setSelMyCourse(item)
    setShowEditModal(true)
  }
  const handleSelectPlanMode = useCallback((planMode: MyCourseEnum) => {
    setMyCourseMode(planMode)
    if (planMode !== MyCourseEnum.Library) {
      setShowMyCourses(false);
      setShowFilterMenu(false);
    } else {
      setShowMyCourses(true);
      setShowFilterMenu(false);
    }
  }, [setShowFilterMenu, setShowMyCourses]);

  const handleResetFilters = useCallback(() => {
    setFilters([]);
    setFilteredAge([]);
    setFilteredSkill([]);
    setAgeFilter(false);
    setSkillFilter(false);
    setTopicFilter(false);
  }, []);

  const handleShowFilters = () => {
    setIsApplied(false);
    setTimeout(() => {
      setShowMyCourses(current => !current)
      setShowFilterMenu(current => !current)
    }, 200)
  }

  const handleSelectAgeFilter  = useCallback(() => {
    setAgeFilter(current => !current);
    setSkillFilter(false);
    setTopicFilter(false);
  }, [])

  const handleSelectSkillFilter  = useCallback(() => {
    setAgeFilter(false);
    setSkillFilter(current => !current);
    setTopicFilter(false);
  }, [])

  const handleSelectTopicFilter  = useCallback(() => {
    setAgeFilter(false);
    setSkillFilter(false);
    setTopicFilter(current => !current);
  }, [])

  const handleChangeOptions = useCallback((setter: any) => (value: any) => {
    setter(value)
  }, []);

  // const handleChangeSearch = useCallback((value: TextInputValue) => {
  //   setSearch(value.toString());
  // }, []);

  const handleChangeFilters = useCallback((value: string[]) => {
    const ageGroups = value.filter(group => group.includes('Age:'))
    const ageTemp = ageGroups.map(group => {
      return group.replace('Age: ', '')
    })
    setFilteredAge(ageTemp)

    const chagedSkills = value.filter(group => group.includes('Skill:'))

    const skillTemp = chagedSkills.map(group => {
      return group.replace('Skill: ', '')
    })
    const skills = skillTemp.map((skillLabel) => {
      return standaloneLessonsSelCompetencies.find(skill => skill.label === skillLabel)?.value ?? ''
    })
    setFilteredSkill(skills ? skills : [])

    const changedTopics = value.filter(group => group.includes('Topic:'))
    const temp = changedTopics.map(group => {
      return group.replace('Topic: ', '')
    })
    setFilteredTopic(temp)

    if (value.length === 0) {
      handleResetFilters()
    }
    setFilters(value);
  }, [handleResetFilters])

  const handleFilterApply = useCallback(() => {
    var filterOptions: string[] = []
    if (filteredAge.length > 0) {
      filteredAge.forEach(ageGroup => {
        filterOptions.push(`Age: ${ageGroup}`)
      })
    }
    if (filteredSkill.length > 0) {
      const skills = filteredSkill.map((skillValue) => {
        return standaloneLessonsSelCompetencies.find(skill => skill.value === skillValue)?.label
      })
      skills.forEach(skill => {
        filterOptions.push(`Skill: ${skill}`)
      })
    }
    if (filteredTopic.length > 0) {
      filteredTopic.forEach(topic => {
        filterOptions.push(`Topic: ${topic}`)
      })
    }
    setFilters(filterOptions)
    setIsApplied(true);
    setShowFilterMenu(current => !current)
    setShowMyCourses(current => !current)
    setAgeFilter(false);
    setSkillFilter(false);
    setTopicFilter(false);
  }, [filteredAge, filteredSkill, filteredTopic])

  const handleLessonHovered = useCallback((lessonId: string, hovered: boolean) => {
    setHoveredLessonId(lessonId);
    setCardHovered(hovered)
    if (hovered) {
      setTimeout(() => {
        document.getElementById("unitsView")!.style.overflow = "hidden"

      }, 500)
    } else {

      document.getElementById("unitsView")!.style.overflow = "auto"
    }

  }, [])

  const handleOpenLesson = useCallback((course?: SllCourse) => (lesson: SllLesson) => {
    setSelMyCourse(course);
    if (lesson) {
      setSelLesson(lesson);
      history.push(`/standalone/lessons?tab=${myCourseMode === MyCourseEnum.Courses ? '2' : '1'}&lid=${lesson?.id}`);
      setShowLesson(true);
      trackEvent(Events.actions.standaloneLessonOpen, {
        course_name: course?.name,
        lesson_name: lesson.name,
        grade: lesson.ageGroup || lesson.gradeLevel,
        skill: lesson.skill,
        ...(lesson.collections && lesson.collections.length && {
          collection_name: lesson.collections.filter(c => c?.collectionType === 'Theme')[0]?.name,
        }),
        ...(lesson.multiCollections && lesson.multiCollections.length && {
          program_name: lesson.multiCollections[0]?.programType || '',
          multi_collection_name: lesson.multiCollections.map(mc => mc?.name),
        }),
        schoolId: user?.schools?.[0]?.id,
        schoolName: user?.schools?.[0]?.name,
        userId: user?.id,
        userName: `${user?.firstName} ${user?.lastName}`,
      });
    }
    handleLessonHovered('', false)
  }, [history, myCourseMode, trackEvent, handleLessonHovered, user]);

  // Handle movable lesson
  const handleMovableLesson = useCallback((movable: boolean) => {
    setIsMovable(movable);
  }, [setIsMovable])
  // Move Lesson by right arrow
  const handleMoveLessonToCourse = useCallback((lesson: SllLessonFragment) => {
    try {
      var needUpdate = false, newLessons = [''], courseId = ''
      var currentCourses = [...myCourses];
      currentCourses = currentCourses.map((course: any, i: number) => {
        if (course.id === selMyCourse?.id) {
          const exist = course.lessonIds?.find((item: any) => item === lesson.id)
          if (exist) {
            return course
          } else {
            courseId = course.id;
            newLessons = [...course.lessonIds || [], lesson.id]
            needUpdate = true;
            return {
              ...course,
              lessonIds: newLessons
            }
          }
        } else {
          return course
        }
      })
      setMyCourses(currentCourses);
      if (needUpdate) {
        sllUpdateCourse({
          variables: {
            input: {
              id: courseId,
              lessonIds: newLessons
            }
          }
        });
      }
    } catch (e) {
      logger.info(e);
    }
  }, [myCourses, selMyCourse, sllUpdateCourse])

  // Remove Lesson
  const handleRemoveLesson = useCallback((lesson: SllLessonFragment) => {
    var newLessons = [''], planId = ''
    setMyCourses(currentCourses => currentCourses.map((plan: any, i: number) => {
      const exist = plan.lessonIds?.find((item: any) => item === lesson.id)
      if (exist && plan.id === selMyCourse?.id) {
        planId = plan.id
        newLessons = [...plan.lessonIds || []].filter((item: any) => item !== lesson.id)
        return {
          ...plan,
          lessonIds: newLessons
        }
      }
      return plan
    }))

    sllUpdateCourse({
      variables: {
        input: {
          id: planId,
          lessonIds: newLessons
        }
      }
    });
  }, [sllUpdateCourse, setMyCourses, selMyCourse])

  // handle Drag and Drop on Right Side Course
  const handleDnDOnCourseList = useCallback((index: number, units: string[]) => {
    var needUpdate = false, newLessons = [''], planId = ''
    setMyCourses(currentCourse => currentCourse.map((plan: any, i: number) => {
      if (plan.id === selMyCourse?.id) {
        planId = plan.id;
        newLessons = [...units]
        needUpdate = true;
        return {
          ...plan,
          lessonIds: newLessons.reverse()
        }
      } else {
        return plan
      }
    }))
    if (needUpdate) {
      sllUpdateCourse({
        variables: {
          input: {
            id: planId,
            lessonIds: newLessons
          }
        }
      });
    }
  }, [sllUpdateCourse, selMyCourse?.id, setMyCourses]);
  // handle Drag and Drop
  const handleDrop = useCallback(
    (index: number, item: any) => {
      const dropLesson = item.lesson as SllLessonFragment
      if (!selMyCourse?.id || index === 0) {
        if (index > 0) {
          setDndLesson(dropLesson.id)
          setShowEditModal(true)
        }
        return
      }
      try {
        var needUpdate = false, newLessons = [''], planId = ''
        var currentCourses = [...myCourses];
        currentCourses = currentCourses.map((plan: any, i: number) => {
          if (plan.id === selMyCourse?.id) {
            const exist = plan.lessonIds?.find((item: any) => item === dropLesson.id)
            if (exist) {
              return plan
            } else {
              planId = plan.id;
              newLessons = [...plan.lessonIds || [], dropLesson.id]
              needUpdate = true;
              return {
                ...plan,
                lessonIds: newLessons
              }
            }
          } else {
            return plan
          }
        })
        setMyCourses(currentCourses);
        if (needUpdate) {
          sllUpdateCourse({
            variables: {
              input: {
                id: planId,
                lessonIds: newLessons
              }
            }
          });
        }
      } catch (e) {
        logger.info(e);
      }
    }, [myCourses, selMyCourse, sllUpdateCourse]
  );

  //Handle save course name
  const handleSaveChange = ({ name, value, previousValue }) => {
    if (value === '') {
      alert(`You can't change the name with an empty letter. Please try again here.`)
      const item = myCourses.find(course => course.id === name) as SllCourse
      setSelMyCourse(item);
      setShowEditModal(true);
      setMyCourseMode(MyCourseEnum.Library);
      return
    }
    var needUpdate = false
    setMyCourses(currentCourse => currentCourse.map((course: any, i: number) => {
      if (course.id === name) {
        needUpdate = true;
        return {
          ...course,
          name: value
        }
      } else {
        return course
      }
    }))
    if (needUpdate) {
      sllUpdateCourseName({
        variables: {
          input: {
            id: name,
            name: value
          }
        }
      });
    }
  }

  const unitsViewStyle = useMemo(() => {
    const classes = [styles.unitsView];
    if (myCourseMode === MyCourseEnum.Courses) {
      classes.push(styles.leftPanelHidden);
    }
    if (showFilterMenu) {
      classes.push(styles.leftPanelHidden);
    }
    return classes.join(' ');
  }, [myCourseMode, showFilterMenu])

  const leftViewDiv = (sp: SllCourse) => {
    var lessons: SllLesson[] = [];
    (sp?.lessonIds || []).forEach(lessonId => {
      if (sllLessons?.sllGetLessons?.find(lesson => lesson.id && lesson.id === lessonId) as SllLesson !== undefined) {
        lessons.push(sllLessons?.sllGetLessons?.find(lesson => lesson.id && lesson.id === lessonId) as SllLesson)
      }
    })
    return (<div id={sp.id} key={sp.id}>
      <div className={`${styles.courseViewHeader} ${myCourseMode !== MyCourseEnum.Courses ? isTablet ? styles.headTabletStickyView : styles.headStickyView : ''}`}>
        <div className={styles.courseViewTitle}>
          <div className={styles.subItem} style={{background: `${sp.darkColor}`}}>
            <div className={styles.subItemTitle}>{sp.name === "" ? "?" : sp.name.substring(0, 1).toLocaleUpperCase()}</div>
          </div>
          <div className={styles.courseTitle}>
            <EditText
              name={sp.id}
              defaultValue={sp?.name}
              inputClassName={styles.inputCourse}
              onSave={handleSaveChange}
            />
          </div>
        </div>
        {sp?.name && <div className={styles.editCourse} onClick={() => handleShowMyCourses(sp)}>
          <IconPencil fill='white' />
        </div>}
      </div>
      {lessons.length > 0 ?
        <GridLessonsLayout source={0} lessons={lessons.reverse()} studyMode={myCourseMode} handleDrop={handleDrop} handleOpenLesson={handleOpenLesson(sp)} isMovable={isMovable} handleMovableLesson={handleMovableLesson}/>
        : <div className={styles.unitsDivStudyMode}>
            {sp?.name ? <div className={styles.emptyCourseView} onClick={() => handleShowMyCourses(sp)}>
              <div className={styles.insideDiv}>
                <h2>+</h2><span>{'Add Lessons'}</span>
              </div>
            </div> : <div className={styles.blankCourseView} onClick={showAddNewCourse}>
              <div className={styles.insideDiv}>
                <h2>{'+'}</h2>
                <span>{`Create Your First`}<br/> Collection!</span>
              </div>
            </div>}
          </div>
      }
    </div>)
  }

  const lessonMainTopics: string[] = useMemo(() => (sllLessons?.sllGetLessons || []).reduce((prev, lesson) => {
    let currentTopics = [];
    try {
      currentTopics = lesson.mainTopics ? JSON.parse(lesson.mainTopics) : [];
    } catch {
      currentTopics = [];
    }
    let newArray = prev.concat(currentTopics);
    newArray = newArray.filter((item,index)=>{
      return (newArray.indexOf(item) === index)
    });
    return newArray
  }, []), [sllLessons?.sllGetLessons]);
  const topicOptions = useMemo(() => lessonMainTopics.map(topic => ({ label: topic, value: topic })), [lessonMainTopics]);

  const handleScroll = useCallback(() => {
    const navMenuElement = document.getElementById("navMenuBar")
    const leftScrollView = document.getElementById("leftScrollView")
    if (leftScrollView) {
      const rect = leftScrollView.getBoundingClientRect();
      const navBarRect = navMenuElement?.getBoundingClientRect();
      if (rect.top === 0) {
        setNavHidden(false)
        setTopPos(HEADER_HEIGHT);
      } else if (navBarRect && navBarRect.height - (87 - rect.top) < 130) {
        // setNavHidden(true)
        setTopPos(rect.top);
      } else {
        setNavHidden(false)
      }
    }
  }, [])

  const leftMenuStyle = useMemo(() => {
    const classes = [styles.leftMenu];
    if (showFilterMenu) {
      classes.push(styles.filterShow);
    }
    return classes.join(' ');
  }, [showFilterMenu])

  const rightMenuStyle = useMemo(() => {
    const classes = [styles.rightView];
    if (showMyCourses) {
      classes.push(styles.slideShow);
    }
    return classes.join(' ');
  }, [showMyCourses])

  const leftViewStyle = useMemo(() => {
    const classes = [styles.leftView];
    if (showMyCourses) {
      classes.push(styles.slideMove);
    }
    return classes.join(' ');
  }, [showMyCourses])

  const mainViewStyle = useMemo(() => {
    const classes = [styles.libraryView];
    if (!showMyCourses) {
      classes.push(styles.filterMove);
    }
    return classes.join(' ');
  }, [showMyCourses])

  const showAddCourseModal = useCallback(() => {
    setShowModal(true);
  }, []);

  const handleShowLabels = useCallback(() => {
    setShowLabel(current => !current)
  }, [])
  var tab_height = useMemo(() => {
    if (topPos < HEADER_HEIGHT) {
      return 0
    }
    return middleWidth ? smallWidth ? 120 : 160 : 203
  }, [middleWidth, smallWidth, topPos]);

  const handleHoverLesson = useCallback((lessonId: string, hovered: boolean) => {
    setTopPos(87);    // Make nav tab smaller on Quick info
    setNeedBottomPadding(hovered);
    setTimeout(() => {
      const lessonElement = document.getElementById(lessonId);
      if (lessonElement) {
        lessonElement.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
      }

      setTimeout(() => {
        handleLessonHovered(lessonId, hovered)
      }, 100)
    }, 200)
  }, [handleLessonHovered]);

  const onCloseInfo = () => {
    setHoveredLessonId('')
    setNeedBottomPadding(false)
    setCardHovered(false)
    const navMenuElement = document.getElementById("navMenuBar")
    if (navMenuElement) {
      navMenuElement.style.display = 'flex'
      setTopPos(HEADER_HEIGHT);
    }
    setNavHidden(false);
    document.getElementById("unitsView")!.style.overflow = "auto"
  }

  const handleSelectedCenterCard = useCallback((centerCard: boolean) => {
    setCenterCard(centerCard)
  }, [])

  const lessonsViewByAge = useCallback((sp: SllCourse) => {
    var lessons: SllLesson[] = [];
    (sp?.lessonIds || []).forEach(lessonId => {
      if (sllLessons?.sllGetLessons?.find(lesson => lesson.id && lesson.id === lessonId) as SllLesson !== undefined) {
        lessons.push(sllLessons?.sllGetLessons?.find(lesson => lesson.id && lesson.id === lessonId) as SllLesson)
      }
    })
    return (<div id={sp.id} key={sp.id}>
      <div className={`${styles.groupHead} ${isTablet ? styles.headTabletStickyView : styles.headStickyView}`}>
        <div className={styles.courseViewTitle}>
          <div>
            <div className={styles.groupTitle}>{sp.name}</div>
          </div>
        </div>
      </div>
      {lessons.length > 0 ?
        <GridLessonsLayout source={0} lessons={lessons.reverse()} studyMode={myCourseMode} handleOpenLesson={handleOpenLesson(sp)}
          handleDrop={handleDrop} showLabel={showLabel}
          handleLeftArrowAction={handleMoveLessonToCourse} isMovable={isMovable} handleMovableLesson={handleMovableLesson}
          cardHovered={cardHovered} hoveredLessonId={hoveredLessonId} handleSelectedCenterCard={handleSelectedCenterCard}
          handleCardHovered={handleHoverLesson} />
        : null
      }
    </div>)
  }, [
    isTablet,
    sllLessons?.sllGetLessons,
    myCourseMode,
    cardHovered,
    hoveredLessonId,
    showLabel,
    isMovable,
    handleOpenLesson,
    handleDrop,
    handleHoverLesson,
    handleMovableLesson,
    handleMoveLessonToCourse,
    handleSelectedCenterCard
  ]);

  const unitListView = (
    <div className={unitsViewStyle}>
      {<div id={'leftScrollView'} className={myCourseMode === MyCourseEnum.Courses ? styles.studyModeBackground : ''} style={{height: '100%'}}>
        <TabLayout studyMode={myCourseMode} handleSelectPlanMode={handleSelectPlanMode} topPos={topPos}/>
        {myCourseMode !== MyCourseEnum.Courses ?
          <div className={styles.mainView} style={{display: showMyCourses ? 'flex' : 'inline', paddingBottom: needBottomPadding ? 700 : 100}}>
            <div className={mainViewStyle}>
              <div className={`${styles.groupHead} ${isTablet ? styles.headTabletStickyView : styles.headStickyView}`}>
                <MainFilterLayout
                  filters={filters} showFilters={showFilterMenu}
                  handleChangeFilters={handleChangeFilters} handleResetFilters={handleResetFilters}
                  handleShowFilters={handleShowFilters}
                />
                <div className={styles.checkAgeView} onClick={handleShowLabels}>
                  <Switch checked={showLabel} /> <span>{'Show Age Labels'}</span>
                </div>
              </div>
              {filters.length > 0 ? <div className={styles.lessonsView} id="lessonsView">
                <GridLessonsLayout source={0} target={selMyCourse?.name} lessons={filtered} studyMode={myCourseMode}
                  handleDrop={handleDrop} handleOpenLesson={handleOpenLesson(undefined)} showLabel={showLabel}
                  handleLeftArrowAction={handleMoveLessonToCourse} isMovable={isMovable} handleMovableLesson={handleMovableLesson}
                  cardHovered={cardHovered} hoveredLessonId={hoveredLessonId} handleSelectedCenterCard={handleSelectedCenterCard}
                  handleCardHovered={handleHoverLesson}/>
              </div> : lessonsByAge.map(grade => lessonsViewByAge(grade))}
            </div>
            {showFilterMenu && <div className={styles.backdrop} onClick={handleFilterApply}>
              <button className={styles.closeWrapper}>
                <CloseIcon className={styles.closeIcon}/>
              </button>
            </div>}
            <div className={leftMenuStyle}>
              <div className={styles.leftMenuContainer}>
                <div className={styles.filterListTitle}>Filter by:</div>
                <div className={styles.filterItems}>
                  <div className={styles.filterItem} onClick={handleSelectAgeFilter}>
                    <div className={styles.filterItemTitle}>{'Age Group'}</div>
                    <div className={[styles.dropdownToggle, ageFilter ? styles.dropdownToggleClose : styles.dropdownToggleOpen].join(' ')}/>
                  </div>
                  <Collapse isOpened={ageFilter}>
                    <div className={styles.filterSubView} >
                      <SubFilterSelect filterOptions={standaloneLessonsAgeOptions} filters={filteredAge} handleChangeTopic={handleChangeOptions(setFilteredAge)} open={ageFilter} />
                    </div>
                  </Collapse>
                  <div className={styles.filterItem} onClick={handleSelectSkillFilter}>
                    <div className={styles.filterItemTitle}>{'Competency'}</div>
                    <div className={[styles.dropdownToggle, skillFilter ? styles.dropdownToggleClose : styles.dropdownToggleOpen].join(' ')}/>
                  </div>
                  <Collapse isOpened={skillFilter}>
                    <div className={styles.filterSubView} >
                      <SubFilterSelect filterOptions={standaloneLessonsSelCompetencies} filters={filteredSkill} handleChangeTopic={handleChangeOptions(setFilteredSkill)} open={skillFilter} />
                    </div>
                  </Collapse>
                  <div className={styles.filterItem} onClick={handleSelectTopicFilter}>
                    <div className={styles.filterItemTitle}>{'Topic'}</div>
                    <div className={[styles.dropdownToggle, topicFilter ? styles.dropdownToggleClose : styles.dropdownToggleOpen].join(' ')}/>
                  </div>
                  <Collapse isOpened={topicFilter}>
                    <div className={styles.filterSubView} >
                      <SubFilterSelect filterOptions={topicOptions} filters={filteredTopic} handleChangeTopic={handleChangeOptions(setFilteredTopic)} open={topicFilter} />
                      {/* <SubFilterSelect label='Sub Topic' filterOptions={topicOptions} filters={filteredSubTopic} handleChangeTopic={handleChangeOptions(setFilteredSubTopic)} /> */}
                    </div>
                  </Collapse>
                  {/* <div className={styles.searchItem}>
                    <div className={styles.filterItemTitle}>{'Search'}</div>
                    <TextInput placeholder={''} label={''} id={'search'} value={search} onChange={handleChangeSearch}/>
                  </div> */}
                </div>
                <div className={styles.filterAction}>
                  <Button className={styles.filterApplyButton} label='Apply Filters' size='small' onClick={handleFilterApply} />
                </div>
              </div>
              <div style={{ flexGrow: 1 }}>
              </div>
            </div>
            <div className={rightMenuStyle} id="courseView">
              <div className={styles.rightMenuContainer} style={{height: `calc(100vh - ${tab_height}px - ${HEADER_HEIGHT}px)`}}>
                <div className={styles.planListTitle}>Edit My Collections:</div>
                {myCourses.map((item, i) => {
                  var myCourseLessons: SllLesson[] = [];
                  item.lessonIds?.forEach(lessonId => {
                    if (sllLessons?.sllGetLessons?.find(lesson => lesson.id && lesson.id === lessonId) as SllLesson !== undefined) {
                      myCourseLessons.push(sllLessons?.sllGetLessons?.find(lesson => lesson.id && lesson.id === lessonId) as SllLesson)
                    }
                  })
                  return (
                    <div key={i}>
                      <div className={styles.planItemContainer}>
                        <div className={styles.planItem} style={{background: `${item.darkColor}`, borderBottomLeftRadius: (item.id === selMyCourse?.id) ? 0 : '3px', borderBottomRightRadius: (item.id === selMyCourse?.id) ? 0 : '3px'}} onClick={() => handleSelCourse(item)}>
                          <div className={styles.subItem} style={{background: `#FFFFFF`}}>
                            <div className={styles.subItemTitle} style={{color: `${item.darkColor}`}}>{item.name === "" ? "?" : item.name.substring(0, 1).toLocaleUpperCase()}</div>
                          </div>
                          <div className={styles.planName} style={{color: `white`}}>
                            {item.name === "" ? "No Name" : `${item.name}`}<br/>
                            <span>{item.name === "" ? '' : 'Collection'}</span>
                          </div>
                          <div className={styles.editPlan} onClick={handleEditCourse(item)}>
                            <IconPencil fill={`white`} />
                          </div>
                          {(myCourseMode === MyCourseEnum.Library && !isMobile) && <div className={[styles.courseToggle, selMyCourse?.id === item.id ? styles.courseToggleClose : styles.courseToggleOpen].join(' ')}/>}
                        </div>
                      </div>
                      <div className={styles.planUnitsView} style={{background: `${item.color}`}}>
                      <Collapse isOpened={(myCourseMode === MyCourseEnum.Library && item.id === selMyCourse?.id)}>
                        <GridLessonsLayout source={i+1} lessons={myCourseLessons.reverse()} studyMode={myCourseMode} course={item} handleDrop={handleDrop} handleRightArrowAction={handleRemoveLesson} handleDnDOnCourseList={handleDnDOnCourseList} isMovable={isMovable} handleMovableLesson={handleMovableLesson} showLabel={showLabel}/>
                      </Collapse></div>
                    </div>
                  )
                })}
                {myCourseMode === MyCourseEnum.Library && <div className={styles.itemWrapper}>
                  <div className={styles.separateView}></div>
                  <Button className={styles.addCourseButton} label='+ Add New Collection' size='small' onClick={showAddCourseModal} />
                </div>}
              </div>
              <div style={{ flexGrow: 1 }}>
              </div>
            </div>
          </div>
          : <div style={{paddingBottom: '100px'}}>{myCourses.map(sp => leftViewDiv(sp))}</div>
        }</div>
      }
    </div>
  )

  const coursesForSelectedLesson: SllCourse[] = useMemo(() => {
    if (!selLesson?.id) {
      return [];
    }
    return myCourses.filter((plan) => (plan.lessonIds || []).includes(selLesson?.id!));
  }, [selLesson?.id, myCourses]);

  const coursesForSelectedLessonIds = useMemo(() => coursesForSelectedLesson.map(unit => unit.id), [coursesForSelectedLesson]);

  const closeModal = () => {
    setShowLesson(false);
    setSelLesson(null);
    setNeedBottomPadding(false)
    history.replace(`/standalone/lessons?tab=${myCourseMode === MyCourseEnum.Courses ? '2' : '1'}`);
  };

  const handleAddLessonToCourse = useCallback(async (courseId: string) => {
    if (courseId) {
      const selectedCourse = myCourses.find(plan => plan.id === courseId);
      if (selectedCourse && selLesson?.id) {
        await sllUpdateCourse({
          variables: {
            input: {
              id: courseId,
              lessonIds: [...(selectedCourse?.lessonIds || []), selLesson?.id]
            }
          }
        });
        setShowModal(false);
      }
    }
  }, [selLesson?.id, myCourses, sllUpdateCourse]);

  const handleConfirmRemove = useCallback(async () => {
    if (deletingCourseId) {
      const deleted = await sllDeleteCourse({
        variables: {
          input: { id: deletingCourseId }
        }
      });
      if (deleted.data?.sllDeleteCourse) {
        const courses = await sllGetCourses();
        if (courses.data?.sllGetCourses?.length === 0) {
          setMyCourses([])
          setIsDefault(false)
        }
      }
      setRemoveConfirmation(false);
    }
  }, [sllDeleteCourse, deletingCourseId, sllGetCourses]);

  const handleCancel = useCallback(() => {
    setRemoveConfirmation(false);
  }, []);

  const handleConfirmRemoveCourse = useCallback((courseId: string) => {
    setShowEditModal(false)
    setDeletingCourseId(courseId);
    setRemoveConfirmation(true);
  }, []);
  const removeCourseName = useMemo(() => {
    if (!!deletingCourseId) {
       const removeStudy = myCourses.filter(plan => plan.id === deletingCourseId)
       return removeStudy.length > 0 ? removeStudy[0].name : ''
    }
    return ''
  },[deletingCourseId, myCourses])

  const HTML5toTouch = {
    backends: [
      {
        id: "html5",
        backend: HTML5Backend,
        transition: MouseTransition
      },
      {
        id: "touch",
        backend: TouchBackend,
        options: { enableTouchEvents: true },
        preview: true,
        transition: TouchTransition,
        skipDispatchOnTransition: true
      }
    ]
  };

  return (
    <>
      <Header isHidden={navHidden}/>
      <div className={styles.wrapper}>
        {isComingSoon ? <div className={styles.comingpage}>
          <h2>
            This page is being replaced by our new <strong>Lesson Library</strong>, which will be released on August 5th. <br/>
            Lessons will not be available during this transition. <br/>
            We apologize for the inconvenience.
          </h2>
        </div> :
        <DndProvider options={HTML5toTouch}>
          {courseLoading || loading || creating ? <div className={styles.spinner}><Spinner /></div> : <>
          <div id="customunits" className={styles.page}>
            <div id="unitsView" className={leftViewStyle} onScroll={handleScroll}>
              {unitListView}
            </div>

            <div className={styles.gradientView}></div>
          </div>
          </>}
        </DndProvider>}
        {cardHovered && <div>
          <div className={styles.blurBackground} onClick={onCloseInfo} style={{bottom: centerCard ? -500 : -300}}/>
        </div>}
      </div>
      {showModal && <AddCourse open={showModal} courses={myCourses} creating={creating || updating} onClose={() => setShowModal(false)} onCreateNew={handleAddNewCourse} onAddLessonToCourse={selLesson?.id ? handleAddLessonToCourse : undefined} coursesForSelectedLessonIds={coursesForSelectedLessonIds} />}
      {removeConfirmation ? <DeleteModal size='small' open={removeConfirmation} onClose={handleCancel} onDelete={handleConfirmRemove} message={`Are you sure you want to delete ${removeCourseName} Collection?`} loading={deletingCourse || courseLoading} cancelLabel={'NO'} deleteLabel={'DELETE'} /> : null}
      {showEditModal && <EditCourse open={showEditModal} course={selMyCourse} courses={myCourses} creating={creating || updating1} onClose={() => setShowEditModal(false)} onUpdateCourse={handleUpdateCourse} onRemoveCourse={handleConfirmRemoveCourse} lessonId={dndLesson} />}
      {(showLesson && selLesson) && <LessonProgressModal open={showLesson} onClose={closeModal} lessonId={selLesson.id} lessonlist={sllLessons?.sllGetLessons ?? []} courseMode={myCourseMode} course={selMyCourse} addLessonToCollection={showAddCourseModal} coursesForSelectedLesson={coursesForSelectedLesson} gotoCollection={handleMoveToCollection}/>}
    </>
  );
}

export default MyCourses;
